let reqUrl,mqtt_ip;
// let env = process.env.NODE_ENV;
let env = "production";
// 【注】【开发服打包使用npm run development，测试服打包使用npm run test，正式服打包使用npm run build，无需更改其他】
// 【【更改本地调试环境时，请对应修改request.js文件中请求发送拦截器中的内容和http_download_url_new方法中的拼接;以及本页面的env值】】
if (env === "development") {
  // 本地调试接口
  // reqUrl = document.location.protocol + '//api.dessmonitor.com/dis05/'
  // reqUrl = document.location.protocol + '//web.shinemonitor.com/public/'
  reqUrl = document.location.protocol + '//ess.dev.eybond.com/test/' 
  // reqUrl = document.location.protocol + '//47.107.161.18/test/' 
  mqtt_ip = '47.107.128.73:8093/mqtt' 
  // reqUrl = document.location.protocol + '//47.107.161.18/test/' 
  // reqUrl = document.location.protocol + '//172.16.1.193:9091/public/' 
  // reqUrl = document.location.protocol + '//172.16.1.7:9091/public/' 
  // reqUrl = document.location.protocol + '//172.16.1.34:9091/public/'
  // reqUrl = document.location.protocol + '//172.16.1.193:9091/public/'
  // reqUrl = document.location.protocol + '//47.107.161.18/test/'

  // reqUrl = document.location.protocol + '//web1.dessmonitor.com/public/'
  // reqUrl = document.location.protocol + '//web1.dessmonitor.com/dis05/'
  // reqUpgUrl = document.location.protocol + '//192.168.1.100:8888'
  // 宁波德业
  // reqUrl = document.location.protocol + '//ess.test.eybond.com/recharge/'
  // reqUrl = document.location.protocol + '//192.168.1.216:9090/public'
  // reqUrl = 'http://39.108.19.162:9094/public/'
  // reqUrl = document.location.protocol + '//172.16.1.37:9091/public/'
  // reqUrl = document.location.protocol + '//172.16.1.156:9091/public/'
  // 
  // reqUrl = document.location.protocol + '//39.108.19.162:1301/test/'
  // 储能测试服
  // reqUrl = document.location.protocol + '//172.16.1.156:9091/public/'

  // reqUrl = '/api'
  // reqUrl = '/ceshi'
  // reqUrl = 'http://solar.eybond.com/haiwang/'
} else if (env === "test") {
  // 线上接口
  // reqUrl = document.location.protocol + '//api.dessmonitor.com/dis05/'
  // reqUrl = document.location.protocol + '//web.shinemonitor.com/public/'
  reqUrl = document.location.protocol + '//ess.test.eybond.com/test/'
  mqtt_ip = 'api.test.valueclouds.com/mqtt' 
  // reqUrl = document.location.protocol + '//ess.dev.eybond.com/test/'
  // 宁波德业
  // reqUrl = document.location.protocol + "//solar.eybond.com/recharge/";
  // reqUrl = document.location.protocol + '//39.108.19.162:1301/test/'

  // reqUrl = document.location.protocol + '//solar.eybond.com/test/'
  // reqUrl = 'http://solar.eybond.com/haiwang/'
} else if (env === "production") {
  // 线上接口
  // reqUrl = document.location.protocol + '//api.dessmonitor.com/dis05/'
  reqUrl = document.location.protocol + '//web.dessmonitor.com/public/'
  mqtt_ip = 'mqtts.valueclouds.com/mqtt' 
  // reqUrl = document.location.protocol + '//ess.test.eybond.com/test/'
  // 宁波德业
  // reqUrl = document.location.protocol + "//solar.eybond.com/recharge/";
  // reqUrl = document.location.protocol + '//39.108.19.162:1301/test/'

  // reqUrl = document.location.protocol + '//solar.eybond.com/test/'
  // reqUrl = 'http://solar.eybond.com/haiwang/'
}

export default {
  API_ROOT: reqUrl,
  env: env,
  MQTT_IP: mqtt_ip,
  CONTENT_TYPE: "application/x-www-form-urlencoded",
  COMPANY_KEY: "bnrl_frRFjEz8Mkn",
};
